<template>
	<div
		v-if="isBlockShown"
		:class="['panel',
			isHeaderIndent? 'mt-0 pt-0' : '',
			isFooterIndent? 'mb-0 pb-0' : '',
			block.appearance? block.appearance : ''
		]"
	>
		<div class="container">
			<div v-if="isHeaderVisible" class="panel_header">
				<h2 v-if="block.block_title">
					{{ block.block_title }}
				</h2>
			</div>
			<div class="row">
				<div :class="['col-12',isRightColumn? 'col-lg-12' : 'col-lg-6']">
					<div class="h-100 d-flex justify-content-center flex-column py-4 pr-lg-5">
						<div v-if="block.description" class="title">
							<h1>
								{{ block.description }}
							</h1>
						</div>
						<div v-if="block.text" v-html="block.text" />
						<div v-if="isAlumni">
							<a class="btn btn-primary mb-0" :href="getUriAlumniMainPage()">
								Перейти
							</a>
						</div>
						<div v-else>
							<div v-if="statusSending && sending">
								<button class="btn btn-primary mb-0" @click="sendRequest">
									<b-spinner v-if="loader" style="margin-right: 15px; width: 1.3em; height: 1.3em;" />
									<span v-if="loader">Отправляется</span>
									<span v-else>Пройти верификацию</span>
								</button>
							</div>
						</div>

						<div v-if="statusSent || statusSuccess" class="alert alert-warning mb-0">
							Спасибо за вашу заявку. Как только мы верифицируем ваш статус,
							вам на почту придет уведомление об этом.
						</div>
					</div>
				</div>

				<div v-if="isBlockShown" class="col-12 col-lg-6">
					<div class="teaser_image_block">
						<div>
							<img :src="block.image" :alt="block.block_title">
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import panel from '~/mixins/panel';
import { mapActions, mapGetters } from 'vuex';
import withAnalytics from '~/mixins/withAnalytics';
import ParseSnippets from '~/components/snippets/ParseSnippets.vue';
import checkIsBlockShown from '~/mixins/checkIsBlockShown';
import alumniPlatform from '~/mixins/alumniPlatform';

export default {
	name: 'PanelAlumniVerify',
	components: {
		ParseSnippets,
	},
	mixins: [panel, withAnalytics, checkIsBlockShown, alumniPlatform],
	data() {
		return {
			statusSuccess: false,
			sending: true,
			loader: false,
		};
	},
	computed: {
		...mapGetters({
			isAlumni: 'profile/isAlumni',
		}),
		isRightColumn() {
			return this.block.right_column_disable === true;
		},
		statusSending() {
			return this.$auth?.user?.is_request_alumni === 0
				|| (!this.$auth.loggedIn || this.$auth?.user === null);
		},
		statusSent() {
			return this.$auth?.user?.is_request_alumni === 1;
		},
	},
	async created() {
		await this.getRoles();
	},
	methods: {
		...mapActions({
			showLoginPopup: 'authModal/showLogin',
			getRoles: 'profile/getRoles',
		}),
		async sendRequest() {
			if (!this.$auth.loggedIn || this.$auth?.user === null) {
				this.showLoginPopup();
			}
			if (this.$auth?.user?.is_request_alumni === 0) {
				this.loader = true;
				const response = await this.$api.alumniRequest(
					this.$route.fullPath,
					this.getAnalyticsData(),
				);
				if (response.result === true) {
					this.statusSuccess = true;
					this.sending = false;
					this.loader = false;
				}
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import 'assets/styles/sk_variables';
// For use bootstrap vars and mixins inside
@import "assets/styles/bootstrap/scss/functions";
@import "assets/styles/bootstrap/scss/variables";
@import "assets/styles/bootstrap/scss/mixins";

@import "assets/styles/components/home/panel-about_program";

.event_overview {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	border-top: 0;
	height: 100%;
	padding: 0 0 2rem 0;

	.title {
		margin-bottom: 0;
	}

	h2 {
		font-size: 2.5rem;
		line-height: 1;
		font-weight: bold;
		margin-bottom: 1rem;
	}
}
</style>
